import { useNavigate, useParams } from "react-router-dom";
import ThemedSpinner from "../components/shared/spinner";
import Typography from "../components/shared/typography";
import TestSummaryItem from "../components/tests/test-summary-item";
import MedicalRecordsSection from "../components/medical-records/medical-records-section";
import { useSetPageContext } from "../hooks/PageContext";
import useLoadTests from "../hooks/useLoadTests";

const TestsPage = () => {
  const { userId } = useParams<{ userId?: string }>();
  const navigate = useNavigate();

  const { tests, isLoading, error } = useLoadTests(userId);
  useSetPageContext(tests);

  if (isLoading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <ThemedSpinner />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto px-4 py-8">
        <Typography variant="h4" className="text-terracotta-500">
          Failed to load tests
        </Typography>
      </div>
    );
  }

  const hasTests = tests.length > 0;

  return (
    <MedicalRecordsSection
      title="Tests"
      buttonLabel="Add Test"
      uploadMessage={`Add test to this user's medical records ${userId ?? ""}`}
      hasRecords={hasTests}
      emptyTitle="No tests listed."
    >
      {hasTests
        ? tests.map((t) => (
            <div
              key={t.id}
              id={`record-test-${t.id}`}
              className="file-record-anchor block scroll-mt-24"
            >
              <TestSummaryItem
                test={t}
                onClick={() => navigate(`/diagnostic-tests/${t.id}`)}
              />
            </div>
          ))
        : null}
    </MedicalRecordsSection>
  );
};

export default TestsPage;
